import React from 'react';
import {
	Grid,
	Button,
	Txt,
	ImageBox,
	SectionWrapper,
	GridItem,
	useCurrentUser,
} from '@eduvision/toolkit';
import { Box } from '@mui/material';
import image from '../images/featured_banner.png';

const FeaturedBannerSection = () => {
	const currentUser = useCurrentUser();

	return (
		<SectionWrapper altBackground>
			<Grid container>
				<Grid item xs={12} sm={6}>
					<ImageBox width="100%" src={image} />
				</Grid>
				<GridItem xs={12} sm={6}>
					<Box flexDirection="column" p="2rem 2rem 2rem 3rem">
						<Txt width="100%" variant="h2" fontWeight="bold" m="0 0 1rem">
              {currentUser ? <>Du brauchst noch mehr Unterstützung für die Umsetzung deiner Idee?</> : <>Sie brauchen noch mehr Unterstützung für die Umsetzung Ihrer Idee?</>} 
						</Txt>
						<Txt width="100%" m="0 0 1rem">
              {currentUser ? <>Lerne unseren Diversity Projektplaner kennen!</> : <>Lernen Sie unseren Diversity Projektplaner kennen!</>}
						</Txt>
						<Button variant="contained" navigateTo="/content/281-diversity-projektplaner">
							Jetzt starten
						</Button>
					</Box>
				</GridItem>
			</Grid>
		</SectionWrapper>
	);
};

export default React.memo(FeaturedBannerSection);
